module.exports = __webpack_public_path__ + "media/native-apps/halsansstig-93515f72.webp";